/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AppointmentState } from '../models/appointment-state';
import { getAllStates } from '../fn/app-state/get-all-states';
import { GetAllStates$Params } from '../fn/app-state/get-all-states';

@Injectable({ providedIn: 'root' })
export class AppStateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllStates()` */
  static readonly GetAllStatesPath = '/api/app-states';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllStates()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllStates$Response(params?: GetAllStates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppointmentState>>> {
    return getAllStates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllStates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllStates(params?: GetAllStates$Params, context?: HttpContext): Observable<Array<AppointmentState>> {
    return this.getAllStates$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AppointmentState>>): Array<AppointmentState> => r.body)
    );
  }

}
